// add header bg on hover
const navElement = document.querySelector('.header-navs');
            const bodyElement = document.body;

            navElement.addEventListener('mouseenter', function() {
                bodyElement.classList.add('header-background');
            });

            navElement.addEventListener('mouseleave', function() {
                bodyElement.classList.remove('header-background');
            });

// custom weglot footer selector
// $('.footer-weglot-mainmenu .lvl_0').click(function() {       
//         $('.footer-weglot-submenu').toggle(); 
//     });
$(document).ready(function() {
    $('.footer-weglot-mainmenu .lvl_0').click(function(event) {
        event.stopPropagation(); 
        $('.footer-weglot-submenu').toggle();
    });

    // Hide submenu when clicking anywhere else on the document
    $(document).click(function() {
        $('.footer-weglot-submenu').hide();
    });

    $('.footer-weglot-submenu').click(function(event) {
        event.stopPropagation();
    });
});


// $('.main_mob_menu').click(function() {       
//     $(this).siblings(".mobile_sub_menu").addClass("second_submenu");
// });
// $('.m-menu__toggle .back_btn').click(function() {  
//      $(this).closest(".mobile_sub_menu").removeClass("second_submenu");
// });

$(document).ready(function() {
$('.disclosure .disclosure__button').click(function() {
  $('.CountryList.disclosure__list').toggle();
});
});


// cookie banner refresh

    function CookiebotCallback_OnLoad() {
        if (Cookiebot.changed) {
            document.location.reload();
        }
    }

    // Listen for the 'CookiebotOnAccept' event
    window.addEventListener('CookiebotOnAccept', function (e) {
        if (Cookiebot.consented) {
            CookiebotCallback_OnLoad();
        }
    }, false);


// add scrolled class in body
  // window.addEventListener('scroll', function () {
  //   const body = document.body;
    
  //   if (window.scrollY > 0) {
  //     body.classList.add('scrolled');
  //   } else {
  //     body.classList.remove('scrolled');
  //   }
  // });


function syncHeaderHeight() {
  const header = document.querySelector('header#shopify-section-header');
  const drawerHeader = document.querySelector('#sidebar-cart .Drawer__Header');
  if (header && drawerHeader) {
    const height = header.offsetHeight;
    drawerHeader.style.height = height + 'px';
    // console.log(`Set .Drawer__Header height to ${height}px`);
  }
}

window.addEventListener('DOMContentLoaded', syncHeaderHeight);
window.addEventListener('scroll', syncHeaderHeight);
window.addEventListener('resize', syncHeaderHeight);

